var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Hidden, Table, TableHead, TableBody, TableRow, TableCell, Typography, } from '@mui/material';
import { formatMoneyAmount } from '../../../utils/format';
var Notice = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font-size: 10px;\n  }\n"], ["\n  && {\n    font-size: 10px;\n  }\n"])));
var OPTIONAL_BREAKDOWNS = ['farm', 'mill', 'producer'];
var SPECIAL_BREAKDOWNS = [
    'auctionBonus',
    'specialTypicaDiscount',
];
var BASE_BREAKDOWNS = [
    'shippingFee',
    'importTax',
    'typica',
    'consumptionTax',
];
export var visibleBreakdownTypes = function (breakdown) {
    var result = [];
    OPTIONAL_BREAKDOWNS.forEach(function (type) {
        if (breakdown[type]) {
            result.push(type);
        }
    });
    result.push.apply(result, BASE_BREAKDOWNS);
    SPECIAL_BREAKDOWNS.forEach(function (type) {
        var _a;
        if (((_a = breakdown[type]) !== null && _a !== void 0 ? _a : 0) > 0) {
            result.push(type);
        }
    });
    return result;
};
var Breakdown = function (_a) {
    var producerName = _a.producerName, originalBreakdown = _a.breakdown, taxName = _a.taxName, currency = _a.currency, priceVersion = _a.priceVersion, vatReverseChargeEnabled = _a.vatReverseChargeEnabled, isJpCalculation = _a.isJpCalculation;
    var t = useTranslation().t;
    var breakdown = React.useMemo(function () { return (__assign(__assign({}, originalBreakdown), { consumptionTax: vatReverseChargeEnabled
            ? 0
            : originalBreakdown.consumptionTax })); }, [originalBreakdown, vatReverseChargeEnabled]);
    var sum = breakdown.farm +
        breakdown.mill +
        breakdown.producer +
        breakdown.shippingFee +
        breakdown.importTax +
        breakdown.typica +
        breakdown.consumptionTax +
        breakdown.auctionBonus -
        breakdown.specialTypicaDiscount;
    var visibleTypes = React.useMemo(function () { return visibleBreakdownTypes(breakdown); }, [breakdown]);
    var labelFor = React.useCallback(function (type) {
        switch (type) {
            case 'producer':
                return producerName;
            case 'consumptionTax':
                return taxName;
            case 'shippingFee':
                return isJpCalculation
                    ? t("pages.invoice.transparencyInformation.shippingFeeForJp")
                    : t("pages.invoice.transparencyInformation.shippingFee");
            case 'importTax':
                return isJpCalculation
                    ? t("pages.invoice.transparencyInformation.importTaxForJp")
                    : t("pages.invoice.transparencyInformation.importTax");
            default:
                return t("pages.invoice.transparencyInformation.".concat(type));
        }
    }, [t, producerName, taxName, isJpCalculation]);
    return (React.createElement("div", null,
        React.createElement(Typography, null,
            "1kg=",
            formatMoneyAmount(sum, currency)),
        React.createElement(Notice, null,
            "(",
            priceVersion === 0
                ? t("pages.invoice.transparencyInformation.oldPriceVersionKgPriceNotice")
                : t("pages.invoice.transparencyInformation.newPriceVersionKgPriceNotice"),
            ")"),
        React.createElement(Hidden, { mdDown: true },
            React.createElement(Table, { "aria-label": "Breakdown" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, visibleTypes.map(function (type) { return (React.createElement(TableCell, { key: type }, labelFor(type))); }))),
                React.createElement(TableBody, null,
                    React.createElement(TableRow, null, visibleTypes.map(function (type) {
                        return (React.createElement(TableCell, { key: type }, formatMoneyAmount(type === 'specialTypicaDiscount'
                            ? -breakdown[type]
                            : breakdown[type], currency)));
                    }))))),
        React.createElement(Hidden, { mdUp: true },
            React.createElement(Table, { "aria-label": "Breakdown" },
                React.createElement(TableBody, null, visibleTypes.map(function (type) { return (React.createElement(TableRow, { key: type },
                    React.createElement(TableCell, { component: "th", scope: "row" }, labelFor(type)),
                    React.createElement(TableCell, { align: "right" }, formatMoneyAmount(type === 'specialTypicaDiscount'
                        ? -breakdown[type]
                        : breakdown[type], currency)))); }))))));
};
export default Breakdown;
var templateObject_1;
